import { FC } from 'react';
// components
import AddSandCoatingForm from 'components/main/SandCoating/Edit';

const AddSandCoating: FC = () => <AddSandCoatingForm />;

export default AddSandCoating;
